import PropTypes from 'prop-types';
import React from 'react';

import { QuaternaryParagraphHeading } from 'components/Headings';
import Image from 'components/ImageV2';
import { IMAGE_WIDTHS } from 'constants/images';

const TopNavigationTileOption = ({ image, title, href, onClick }) => (
  <a href={href} className="TopNavigationTileOption" onClick={onClick}>
    <Image
      src={image}
      alt={title}
      className="TopNavigationTileOption__image"
      width={IMAGE_WIDTHS.W_800}
      ratio="125:36"
    />
    <div className="TopNavigationTileOption__overlay">
      <QuaternaryParagraphHeading className="TopNavigationTileOption__title">
        {title}
      </QuaternaryParagraphHeading>
    </div>

    <style jsx>{`
      .TopNavigationTileOption {
        position: relative;
        text-decoration: none;
        width: 100%;
        overflow: hidden;
      }

      .TopNavigationTileOption__overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    `}</style>
    <style jsx global>{`
      .typography--quaternary-heading.TopNavigationTileOption__title {
        color: white;
        text-transform: uppercase;
        text-align: center;
        overflow: hidden;
      }

      .TopNavigationTileOption:hover * {
        text-decoration: underline;
      }

      .AspectRatio.TopNavigationTileOption__aspect-ratio {
        overflow: hidden;
      }
    `}</style>
  </a>
);

TopNavigationTileOption.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default TopNavigationTileOption;
